import type { DeepPartial } from '../../default/types';
import type { OrderConfig } from '../../default/order/order.types';
import { riskIdentSnippet } from '../../default/order/order';

export const orderConfig: DeepPartial<OrderConfig> = {
  paymentMethods: ['paypal', 'mastercard', 'visa', 'diners', 'discover'],
  hasCo2Compensation: false,
  externalUrls: {
    flexikontoPaymentPause: {
      default: '/service-hilfe/bezahlung-finanzierung/flexikonto-zahlpause',
    },
    appLandingPage: {
      'fr-CH': '/fr/aide-service/avantages/appli',
    },
  },
  premium: {
    enabled: true,
    hasRuntimeOptions: false,
    hasLegalFooter: true,
  },
  newsletterCmsPage: {
    default: 'service-hilfe/service/newsletterservice/anmelden',
    'fr-CH': 'content/service/service-newsletter/sinscrire',
  },
  paylink: {
    paymentMethods: ['mastercard', 'visa', 'diners', 'discover'],
  },
  riskIdent: {
    enabled: true,
    snippetId: riskIdentSnippet('cNp2VX'),
  },
  sovendus: {
    de: {
      trafficSourceNumber: '1153',
      trafficMediumNumber: { default: '3', mobile: '5', app: '42' },
    },
    fr: {
      trafficSourceNumber: '1158',
      trafficMediumNumber: { default: '3', mobile: '9', app: '16' },
    },
  },
};
